import { useEffect, useState } from 'react';
import { Actions } from '../../../client/Actions';
import { useLoaderContext } from '../loader/LoaderContext';

export const useFetchObject = (apiOrFn, deps = []) => {
  const { showLoader, hideLoader } = useLoaderContext();
  const [data, setData] = useState(null);
  const [ready, setReady] = useState(false);

  function loadData() {
    let isActive = true;
    setReady(false);

    showLoader();
    const api = typeof apiOrFn === 'function' ? apiOrFn() : apiOrFn;

    Actions.get(api, (result) => {
      if (isActive) {
        setData(result);
        setReady(true);
        hideLoader();
      }
    });

    return () => {
      isActive = false;
    };
  }

  useEffect(() => {
    return loadData();
  }, deps);

  return { data, ready, loadData };
};
